import { AdvancedAnalysisSchema } from "@/components/AdvancedAnalysis/models/AdvancedAnalysisSchema"
import { AnalysisConfigSchema } from "@/components/AnalysisConfig/models/AnalysisConfigSchema"
import { CalculationSchema } from "@/components/CustomCalculations/models/CalculationSchema"
import { CustomReportSchema } from "@/components/CustomReports/models/CustomReportSchema"
import { RuleSchema } from "@/components/DataCleaning/models/RuleSchema"
import { PlotSchema } from "@/components/Plotting/models/PlotSchema"
import { TableSchema } from "@/components/Tables/models/TableSchema"


export type CdnSchemaTypeToSchemaMap = {
    [CdnSchemaType.RuleSchema]: RuleSchema
    [CdnSchemaType.AnalysisConfigSchema]: AnalysisConfigSchema
    [CdnSchemaType.CalculationSchema]: CalculationSchema
    [CdnSchemaType.PlotSchema]: PlotSchema
    [CdnSchemaType.TableSchema]: TableSchema
    [CdnSchemaType.CustomReportSchema]: CustomReportSchema
    [CdnSchemaType.AdvancedAnalysis]: AdvancedAnalysisSchema
}

export enum CdnSchemaType {
    RuleSchema = "rule_schema",
    AnalysisConfigSchema = "analysis_config_schema",
    CalculationSchema = "calculation_schema",
    PlotSchema = "plot_schema",
    TableSchema = "table_schema",
    CustomReportSchema = "custom_report_schema",
    AdvancedAnalysis = "advanced_analysis_schema"
}

